const OnboardingConstants = {
  OnboardingClassCreatedOrJoined: 'OnboardingClassCreatedOrJoined',
  OnboardingAssignmentCreated: 'OnboardingAssignmentCreated',
  OnboardingAssignmentsStarted: 'OnboardingAssignmentsStarted',
  OnboardingAssignmentResultsReviewed: 'OnboardingAssignmentResultsReviewed'
};

export default OnboardingConstants;
